import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "../../../../../ui/sheet";
import LookupValuesEditor from "../shared/LookupValuesEditor";

/**
 * Right-side panel hosting the benefit-signal lookup-value editor.
 *
 * `kind="benefit-signals"` maps to backend lookup_kind=BENEFIT_SIGNAL — same
 * CRUD surface as departments / roles, just a different path segment.
 */
const SignalCatalogPanel = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="right" className="overflow-y-auto p-6">
      <SheetHeader>
        <SheetTitle>Benefit signals</SheetTitle>
        <SheetDescription>
          Signals are the topics ARIS listens for when deciding which benefits
          to surface. Add the ones that matter most for your members — for
          example "Eldercare load" or "Burnout".
        </SheetDescription>
      </SheetHeader>
      <div className="mt-6">
        <LookupValuesEditor
          kind="benefit-signals"
          singular="signal"
          plural="signals"
        />
      </div>
    </SheetContent>
  </Sheet>
);

export default SignalCatalogPanel;
